package empiresmp.feature.gallery.ui

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.UserSelect
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.userSelect
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.graphics.Image
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.percent
import ru.astrainteractive.kobwebx.core.resource.Resources
import ru.astrainteractive.kobwebx.core.theme.composable.LocalSitePalette

@Composable
internal fun NextComposable(
    type: NextType,
    onClick: () -> Unit,
) {
    val theme = LocalSitePalette.current
    Box(
        Modifier.Companion
            .width(20.percent)
            .padding(theme.dimens.M)
            .backgroundColor(theme.colors.colorSecondary.toRgb().copy(alpha = 230))
            .color(theme.colors.colorSecondaryVariant)
            .userSelect(UserSelect.Companion.None)
            .borderRadius(theme.dimens.S)
            .onClick {
                it.stopPropagation()
                it.preventDefault()
                onClick.invoke()
            }
            .cursor(Cursor.Companion.Pointer),
        contentAlignment = Alignment.Center
    ) {
        Image(
            src = Resources.iconArrowUp.path,
            modifier = Modifier.Companion
                .size(theme.dimens.XL)
                .thenIf(type == NextType.PREV, Modifier.Companion.rotate(90.unaryMinus().deg))
                .thenIf(type == NextType.NEXT, Modifier.Companion.rotate(90.deg))

        )
    }
}
internal enum class NextType {
    NEXT, PREV
}
